import axios from 'axios';

// 确定基础 URL - 统一使用相对路径
const BASE_URL = process.env.REACT_APP_API_URL || '/api';

// 定义一个用于处理认证失败的函数
let handleAuthFailure = null;

// 设置认证失败处理函数
export const setAuthFailureHandler = (handler) => {
  handleAuthFailure = handler;
};

// 默认的认证失败处理函数
const defaultAuthFailureHandler = () => {
  // 清除本地存储的认证信息
  localStorage.removeItem('auth-storage');
  localStorage.removeItem('user');
  
  // 跳转到登录页面
  if (window.location.pathname !== '/login') {
    window.location.href = '/login';
  }
};

/** 前端请求超时（毫秒）。AI Writer / 长耗时接口建议 ≥ 240000；可通过 REACT_APP_API_TIMEOUT_MS 覆盖 */
const API_TIMEOUT_MS = parseInt(process.env.REACT_APP_API_TIMEOUT_MS || '240000', 10); // 4 minutes

const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: API_TIMEOUT_MS,
});

// 请求拦截器
apiClient.interceptors.request.use(
  config => {
    // 从本地存储获取 token
    const token = localStorage.getItem('auth-storage') 
      ? JSON.parse(localStorage.getItem('auth-storage')).state.token
      : null;
    
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    
    // 请求体脱敏
    const redacted = config.data && typeof config.data === 'object'
      ? { ...config.data }
      : config.data;
    if (redacted && typeof redacted === 'object') {
      if ('password' in redacted) redacted.password = '[REDACTED]';
    }
    console.log(`[API] ${config.method.toUpperCase()} ${config.url}`, redacted);
    return config;
  },
  error => {
    console.error('[API Request Error]', error);
    return Promise.reject(error);
  }
);

// 响应拦截器
apiClient.interceptors.response.use(
  response => {
    // 响应体脱敏
    let payload = response.data;
    if (payload && typeof payload === 'object') {
      const clone = { ...payload };
      if ('token' in clone) clone.token = '[REDACTED]';
      console.log(`[API Response] ${response.status}`, clone);
    } else {
      console.log(`[API Response] ${response.status}`, payload);
    }
    return response;
  },
  error => {
    console.error('[API Response Error]', error);
    console.error('详细错误:', error.response?.data || '无响应数据');
    
    // 处理401认证失败
    if (error.response?.status === 401) {
      console.log('[API] 检测到401认证失败，触发认证失败处理');
      
      // 调用自定义认证失败处理函数，如果没有设置则使用默认处理函数
      if (handleAuthFailure) {
        handleAuthFailure();
      } else {
        defaultAuthFailureHandler();
      }
    }
    
    return Promise.reject(error);
  }
);

export default apiClient;

// Auth 服务
export const authService = {
  register: (userData) => apiClient.post('/auth/register', userData),
  login: (credentials) => apiClient.post('/auth/login', credentials),
  getProfile: () => apiClient.get('/auth/me'),
  forgotPassword: (email) => apiClient.post('/auth/forgot-password', { email }),
  resetPassword: (token, password) => apiClient.post('/auth/reset-password', { token, password }),
};
